/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {
  AdnHttpSender,
  createAdnHttpResourceSender
} from '../../../util/create-adn-http-resource';
import {bidUpdateDebug} from './bid-data-export';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable({
  providedIn: 'root'
})
export class BidsService {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  bidUpdates(lineItemId: string): any {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['bidupdates', 'lineitem', lineItemId]),
      params: {}
    });
  }

  bidUpdatesDebug(): any {
    return Promise.resolve(bidUpdateDebug);
  }
}
